// Wing motif — the signature of "Alas Enlazadas" (linked wings).
export function Wings({ className, color = "currentColor" }) {
  return (
    <svg viewBox="0 0 120 40" fill="none" aria-hidden="true" className={className}>
      <g stroke={color} strokeWidth="1.4" strokeLinecap="round" fill="none" opacity="0.9">
        {/* left wing */}
        <path d="M58 20 C46 12 32 10 20 12" />
        <path d="M58 22 C46 16 30 16 16 20" />
        <path d="M58 24 C48 22 34 24 22 30" />
        {/* right wing */}
        <path d="M62 20 C74 12 88 10 100 12" />
        <path d="M62 22 C74 16 90 16 104 20" />
        <path d="M62 24 C72 22 86 24 98 30" />
      </g>
      {/* linked center */}
      <circle cx="60" cy="21" r="2.4" fill={color} />
    </svg>
  );
}

// A quiet section divider using the wing motif.
export function WingDivider({ className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-4 ${className}`} aria-hidden="true">
      <span className="h-px w-16 bg-gradient-to-r from-transparent to-line md:w-24" />
      <Wings className="h-6 w-[92px] text-magenta/70" />
      <span className="h-px w-16 bg-gradient-to-l from-transparent to-line md:w-24" />
    </div>
  );
}
